module.exports = __webpack_public_path__ + "img/arrow-right.7212fe3f.svg";